module.exports = __webpack_public_path__ + "static/media/newshopify4.83310dee.PNG";